// Copyright (c) Mysten Labs, Inc.
// SPDX-License-Identifier: Apache-2.0
import { SVGProps } from 'react';

const SvgCheckStroke16 = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="1em"
		height="1em"
		fill="none"
		viewBox="0 0 16 16"
		{...props}
	>
		<path
			fill="currentColor"
			d="m12.443 3.281-5.78 6.302-2.106-2.296a.88.88 0 0 0-.646-.281.882.882 0 0 0-.642.293c-.17.186-.267.437-.269.7-.002.262.09.515.258.704l2.755 3.004a.882.882 0 0 0 .65.293.882.882 0 0 0 .65-.293l6.43-7.01c.166-.189.26-.442.257-.704a1.048 1.048 0 0 0-.269-.7.882.882 0 0 0-.642-.293.88.88 0 0 0-.646.281Z"
		/>
	</svg>
);
export default SvgCheckStroke16;
